let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1TY4n")).then(() => parcelRequire('2GTGK'));